import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './containers/Home/Home';
import AboutUs from './containers/AboutUs/AboutUs';
import Blogs from './containers/Blogs/Blogs';
import FinancialServices from './containers/FinancialServices/FinancialServices';
import FAQs from './containers/Faqs/Faqs';
import Registration from './components/Registration/Registration';
import LoginModal from './components/LoginModal/LoginModal';
import UserDetail from './components/UserDetail/UserDetail';
import Dashboard from './components/Dashboard/Dashboard';
import Cart from './components/Cart/Cart';
import ProductDetail from './components/ProductDetail/ProductDetail';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyBusiness from './components/ThreeTab/MyBusiness';
import MyAddress from './components/ThreeTab/MyAddress';
import Settings from './components/ThreeTab/Settings';
import ERWPipe from './components/PipeCategories/ERWPipe';
import ProductList from './components/ProductList/ProductList';
import UserTypeMiddleware from './middleware/UserTypeMiddleware';
import AuthMiddleware from './middleware/AuthMiddleware';
import SellerBusiness from './components/ThreeTab/ThreeTab/SellerBusiness';
import VerificationMiddleware from './middleware/VerificationMiddleware';
import AccountVerification from './components/VerifyAccountModal/VerifyAccount';
import PendingVerifyAccount from './components/VerifyAccountModal/PVerifyAccount';
import Loader from './components/Loader/Loader';
import TmtSteel from './components/SteelCategories/TmtSteel';
import Warehouses from './components/TopNavbarComponents/Warehouses';
import TPI from './components/TopNavbarComponents/TPI';
import Transportation from './components/TopNavbarComponents/Transportation';
import CategoryPageWrapper from './components/CategoryPageWrapper ';
import ContactUs from './components/ContactUs/ContactUs';
import BlogDetails from './components/Blog/BlogDetails';
import ExtensiveProductSearch from './components/FooterPages/ExtensiveProductSearch';
import StrategicFinancing from './components/FooterPages/StrategicFinancing';
import SupplyChainManagement from './components/FooterPages/SupplyChainManagement';
import TechnicalSupport from './components/FooterPages/TechnicalSupport';
import ExtendedWarranty from './components/ExtendedWarranty';
import SearchResult from './components/SearchResult/SearchResult';
import ColdRolledCoils from './components/SteelCategories/MildSteel/ColdRolledCoils';
import ColdRolledSheets from './components/SteelCategories/MildSteel/ColdRolledSheets';
import GalvalumeCoils from './components/SteelCategories/MildSteel/GalvalumeCoils';
import GalvanizedCoils from './components/SteelCategories/MildSteel/GalvanizedCoils';
import GalvanizedSheets from './components/SteelCategories/MildSteel/GalvanizedSheets';
import HotRolledCoils from './components/SteelCategories/MildSteel/HotRolledCoils';
import HotRolledSheets from './components/SteelCategories/MildSteel/HotRolledSheets';
import HRPOCoils from './components/SteelCategories/MildSteel/HRPOCoils';
import HRPOSheets from './components/SteelCategories/MildSteel/HRPOSheets';
import WireRodCoils from './components/SteelCategories/MildSteel/WireRodCoils';
import StainlessSteel from './components/StainlessSteel/StainlessSteel';
import Polymer from './components/Polymer/Polymer';

function App() {
	const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
	const [loading, setLoading] = useState(true);
	const toggleModal = () => {
		setIsLoginModalOpen(!isLoginModalOpen);
	};
	useEffect(() => {
		const timer = setTimeout(() => setLoading(false), 2000);
		return () => clearTimeout(timer);
	}, []);
	if (loading) {
		return <Loader
			color="#3f51b5"
			size={80}
			overlayColor="rgba(255,255,255,0.9)"
		/>;
	}

	return (
		<BrowserRouter>
			<Navbar toggleModal={toggleModal} />
			<Header />
			<ToastContainer position="top-right" autoClose={3000} />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/register" element={<Registration />} />
				<Route path="/about-us" element={<AboutUs />} />
				<Route path="/contact-us" element={<ContactUs />} />
				<Route path="/blogs" element={<Blogs />} />
				<Route path="/financial-services" element={<FinancialServices />} />
				<Route path="/faqs" element={<FAQs />} />
				<Route path="/warehouses" element={<Warehouses />} />
				<Route path="/tpi" element={<TPI />} />
				<Route path="/transportation" element={<Transportation />} />
				<Route path="/blog-details" element={<BlogDetails />} />
				<Route path="/extensive-product-search" element={<ExtensiveProductSearch />} />
				<Route path="/strategic-financing" element={<StrategicFinancing />} />
				<Route path="/supply-chain-management" element={<SupplyChainManagement />} />
				<Route path="/technical-support" element={<TechnicalSupport />} />
				<Route path="/extended-warranty" element={<ExtendedWarranty />} />
				<Route path="/category-search" element={<SearchResult />} />
				<Route path="/cold-rolled-coils" element={<ColdRolledCoils />} />
				<Route path="/cold-rolled-sheets" element={<ColdRolledSheets />} />
				<Route path="/galvalume-coils" element={<GalvalumeCoils />} />
				<Route path="/galvanized-coils" element={<	GalvanizedCoils />} />
				<Route path="/galvanized-sheets" element={<GalvanizedSheets />} />
				<Route path="/hot-rolled-coils" element={<HotRolledCoils />} />
				<Route path="/hot-rolled-sheets" element={<HotRolledSheets />} />
				<Route path="/hrpo-coils" element={<HRPOCoils />} />
				<Route path="/hrpo-sheets" element={<HRPOSheets />} />
				<Route path="/wirerod-coils" element={<WireRodCoils />} />
				<Route path="/stainless-steel" element={<StainlessSteel />} />
				<Route path="/polymer" element={<Polymer />} />

				<Route path="/cart" element={<Cart />} />
				<Route path="/product-details/:slug" element={
					<AuthMiddleware>
						<UserTypeMiddleware allowedTypes={['buyer']}>
							<VerificationMiddleware />
							<ProductDetail />
						</UserTypeMiddleware>
					</AuthMiddleware>
				} />
				<Route
					path="/user-details"
					element={
						<AuthMiddleware>
							<UserTypeMiddleware allowedTypes={['buyer', 'seller']}>
								<VerificationMiddleware />
								<UserDetail />
							</UserTypeMiddleware>
						</AuthMiddleware>
					}
				/>
				<Route
					path="/dashboard"
					element={
						<AuthMiddleware>
							<UserTypeMiddleware allowedTypes={['seller', 'buyer']}>
								<VerificationMiddleware />
								<Dashboard />
							</UserTypeMiddleware>
						</AuthMiddleware>
					}
				/>
				<Route
					path="/business"
					element={
						<AuthMiddleware>
							<UserTypeMiddleware allowedTypes={['buyer']}>
								<VerificationMiddleware />
								<MyBusiness />
							</UserTypeMiddleware>
						</AuthMiddleware>
					}
				/>
				<Route
					path="/address"
					element={
						<AuthMiddleware>
							<VerificationMiddleware />
							<UserTypeMiddleware allowedTypes={['buyer', 'seller']}>
								<MyAddress />
							</UserTypeMiddleware>
						</AuthMiddleware>
					}
				/>
				<Route
					path="/setting"
					element={
						<AuthMiddleware>
							<VerificationMiddleware />
							<UserTypeMiddleware allowedTypes={['buyer', 'seller']}>
								<Settings />
							</UserTypeMiddleware>
						</AuthMiddleware>
					}
				/>
				<Route
					path="/seller-business"
					element={
						<AuthMiddleware>
							<UserTypeMiddleware allowedTypes={['seller']}>
								<SellerBusiness />
							</UserTypeMiddleware>
						</AuthMiddleware>
					}
				/>
				{/* <Route path="/categories/:slug" element={<ProductList />} />
        <Route path="/categories/tmt" element={<TmtSteel />} /> */}
				<Route path="/categories/:slug" element={<CategoryPageWrapper />} />

				<Route path="/product/:slug" element={
					<AuthMiddleware>
						<UserTypeMiddleware allowedTypes={['buyer']}>
							<VerificationMiddleware />
							<ERWPipe />
						</UserTypeMiddleware>
					</AuthMiddleware>
				} />
				<Route
					path="/account-verification"
					element={
						<AuthMiddleware>
							<AccountVerification />
						</AuthMiddleware>
					}
				/>
				<Route
					path="/account-pending-verification"
					element={
						<AuthMiddleware>
							<PendingVerifyAccount />
						</AuthMiddleware>
					}
				/>

			</Routes>
			<Footer />
			{isLoginModalOpen && <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />}
		</BrowserRouter>
	);
}

export default App;
